import { EmailActionTypes, CANCEL_EMAIL_UPDATE, RESEND_ACTIVATION_EMAIL } from './types';
import { AppState } from '../index';

export const INITIAL_STATE = { email: { resend: false, updateCancelled: false } };

export default function(state = INITIAL_STATE, action: EmailActionTypes) {
    switch (action.type) {
        case CANCEL_EMAIL_UPDATE:
            return { ...state, email: { updateCancelled: action.payload } };
        case RESEND_ACTIVATION_EMAIL:
            return { ...state, email: { resend: action.payload } };
        default:
            return state;
    }
}

export const selectEmail = (state: AppState) => state.email;
